var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.183.766c.268-.101.485.235.282.438L5.15 7.519.742 5.89c-.544-.181-.544-.966 0-1.208zM7.505 12.713l-1.63-4.409 6.37-6.37c.202-.203.539.015.437.283l-3.97 10.495c-.18.544-1.026.544-1.207 0z"
  })));
};
export default SvgSend;